// Item list order: manual display_order first, then sheets by metal → thickness, others A–Z.
const METAL_RANK = { MS: 0, SS: 1, "GOLDEN 202": 2, GOLDEN: 2 };

const metalOf = (m) => {
  const v = String(m.metal || "").toUpperCase();
  if (v) return v;
  const n = String(m.name || "").toLowerCase();
  return n.includes("golden") ? "GOLDEN" : /\bss\b|steel/.test(n) ? "SS" : "MS";
};

export const isServiceItem = (m) => m.item_type === "SERVICE" || !!m.is_service;
export const isHardwareItem = (m) => String(m.category || "").toLowerCase() === "hardware";
export const isSheetItem = (m) => !isServiceItem(m) && !isHardwareItem(m);

const ord = (m) => (m.display_order == null || m.display_order === "" ? 1e9 : Number(m.display_order));

export function compareItems(a, b) {
  const d = ord(a) - ord(b);
  if (d) return d;
  if (isSheetItem(a) && isSheetItem(b)) {
    const r = (METAL_RANK[metalOf(a)] ?? 3) - (METAL_RANK[metalOf(b)] ?? 3);
    if (r) return r;
    const t = (Number(a.thickness_mm) || 999) - (Number(b.thickness_mm) || 999);
    if (t) return t;
  }
  return String(a.name || "").localeCompare(String(b.name || ""), "en", { sensitivity: "base" });
}

export const sortItems = (list) => [...list].sort(compareItems);

// "2.5 mm" == "2.5mm", case-insensitive; matches name, thickness and gauge.
export const searchKey = (m) => `${m.name || ""} ${m.thickness_mm ? `${m.thickness_mm}mm` : ""} ${m.gauge ? `${m.gauge}g` : ""} ${m.metal || ""}`
  .toLowerCase().replace(/\s+/g, "");
export const normQ = (q) => String(q || "").toLowerCase().replace(/\s+/g, "");
